import { withStyles } from '@mui/styles';

import ApiConnectionForm from './ApiConnectionForm';
import { muiStyles } from './styles';

export default withStyles(muiStyles)(ApiConnectionForm);